import axios, { AxiosError, AxiosPromise, AxiosRequestConfig } from "axios";
import Router from "next/router";
import { Dispatch } from "redux";
import { clearAllCookie, getToken } from "../../utils/Token";

export async function logout({ dispatch }: { dispatch?: Dispatch<any> }) {
  clearAllCookie();
  if (dispatch) {
  }
  Router.push("/accounts/login");
  // window.location.href = location.origin + "/login";
}

let cancelTokenSource = axios.CancelToken.source();

export default function authRequest(
  options: AxiosRequestConfig | any,
  token?: string
): AxiosPromise<any> {
  token = token ?? getToken();
  if (!token) {
    Router.push("/accounts/login");
    // clearAllCookie();
    return Promise.reject(new AxiosError("Invalid Token", "401"));
  }
  cancelTokenSource = axios.CancelToken.source();
  const request = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
    headers: {
      "access-token": token,
    },
    cancelToken: cancelTokenSource.token,
  });

  request.interceptors.response.use(
    function (res) {
      return res;
    },
    function (error) {
      console.log("Error Response Received:", error);
      if (error.response) {
        const status = error.response.status;
        if (status === 401) {
          Router.push("/accounts/login");
        } else if (status === 402) {
          return Promise.reject(error);
        }
      }
      return Promise.reject(error);
    }
  );

  return request(options);
}

export function cancelRequest() {
  cancelTokenSource.cancel();
}

export function isCanceled(err: any) {
  return axios.isCancel(err);
}
